import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import type { ContractCost } from "../lib/types";
import { eur } from "../lib/format";

interface Props {
  costs: ContractCost[];
}

const COLORS = {
  vastrecht: "#9A938A",
  import_marktprijs: "#C66A3D",
  import_belasting: "#8B3A1F",
  terugleverkosten: "#B8860B",
  export_opbrengst: "#2C4A3E",
  inkoopvergoeding: "#4A7560",
  boven_plafond: "#4A7560",
};

export function ContractComparisonChart({ costs }: Props) {
  const data = costs.map((c) => ({
    name: c.contract_name,
    Vastrecht: c.breakdown.vastrecht_eur,
    "Import marktprijs": c.breakdown.import_marktprijs_eur,
    Belasting: c.breakdown.import_belasting_eur,
    Terugleverkosten: c.breakdown.terugleverkosten_eur,
    "− Export opbrengst": -c.breakdown.export_opbrengst_marktprijs_eur,
    "− Inkoopverg.": -c.breakdown.inkoopvergoeding_export_eur,
    "− Boven plafond": -c.breakdown.boven_plafond_opbrengst_eur,
    Totaal: c.total_eur,
  }));

  return (
    <div>
      <div className="serif text-lg font-medium mb-1">Kostenopbouw per contract</div>
      <div className="help mb-3">Positieve balken = kosten, negatieve = opbrengsten. Saldering korting is in belasting verwerkt.</div>
      <ResponsiveContainer width="100%" height={Math.max(280, costs.length * 60)}>
        <BarChart data={data} layout="vertical" stackOffset="sign" margin={{ left: 30, right: 20, top: 10, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#E5DFD3" />
          <XAxis type="number" tick={{ fill: "#6B6661", fontSize: 11 }} tickFormatter={(v) => `€${v.toFixed(0)}`} />
          <YAxis type="category" dataKey="name" tick={{ fill: "#1A1A1A", fontSize: 12 }} width={150} />
          <Tooltip formatter={(v: number) => eur(v)} contentStyle={{ background: "#FFFFFF", border: "1px solid #C9C0B0", borderRadius: 8 }} />
          <Legend wrapperStyle={{ fontSize: 11, paddingTop: 8 }} />
          <Bar dataKey="Vastrecht" stackId="cost" fill={COLORS.vastrecht} />
          <Bar dataKey="Import marktprijs" stackId="cost" fill={COLORS.import_marktprijs} />
          <Bar dataKey="Belasting" stackId="cost" fill={COLORS.import_belasting} />
          <Bar dataKey="Terugleverkosten" stackId="cost" fill={COLORS.terugleverkosten} />
          <Bar dataKey="− Export opbrengst" stackId="cost" fill={COLORS.export_opbrengst} />
          <Bar dataKey="− Inkoopverg." stackId="cost" fill={COLORS.inkoopvergoeding} />
          <Bar dataKey="− Boven plafond" stackId="cost" fill={COLORS.boven_plafond} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
